module.exports = __webpack_public_path__ + "img/car_unknown.ade6fce1.png";